// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e6OWo","top50":"styles_top50__pmt7o"};